import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PaymentDashboardPageRoutingModule } from './payment-dashboard-routing.module';

import { DashboardSearchDesktopComponent } from '@payments/components/dashboard-search/desktop/dashboard-search-desktop.component';
import { DashboardSearchTouchComponent } from '@payments/components/dashboard-search/touch/dashboard-search-touch.component';
import { DashboardSelectorModule } from '@payments/components/dashboard-selector.module';
import { HelpModalComponent } from '@payments/components/help-modal/help-modal.component';
import {
  AccountActivityRowDesktopComponent,
  AccountActivityRowTouchComponent,
  ARAgingRowDesktopComponent,
  ARAgingRowTouchComponent,
} from '@payments/components/payment-dashboard-rows';
import {
  AccountActivityTableComponent,
  ARAgingTableComponent,
} from '@payments/components/payment-dashboard-tables';
import { TerritoryTileComponent } from '@payments/components/territory-tile/territory-tile.component';
import { PaymentsSharedModule } from '@payments/payments-shared/payments-shared.module';
import { SharedModule } from '@shared/shared.module';
import { PaymentDashboardPage } from './payment-dashboard.page';
import { TerritorySelectionComponent } from './territory-selection/territory-selection.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PaymentsSharedModule,
    PaymentDashboardPageRoutingModule,
    SharedModule,
    DashboardSelectorModule,
  ],
  declarations: [
    PaymentDashboardPage,
    AccountActivityTableComponent,
    AccountActivityRowDesktopComponent,
    AccountActivityRowTouchComponent,
    HelpModalComponent,
    TerritoryTileComponent,
    DashboardSearchDesktopComponent,
    DashboardSearchTouchComponent,
    ARAgingTableComponent,
    ARAgingRowDesktopComponent,
    ARAgingRowTouchComponent,
    TerritorySelectionComponent,
  ],
})
export class PaymentDashboardPageModule {}
